import React from 'react';
import _ from 'lodash';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import STLPropertyDetailedAccountModal from './STLPropertyDetailedAccountModal';
import STLPropertyDetailedBillModal from './STLPropertyDetailedBillModal';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class STLProperty extends React.Component {
  constructor(props) {
    super(props);

    this.getBills = this.getBills.bind(this);

    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account Id',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
    ];

    this.allowedAccountKeys = [
      'id',
      'active',
      'externalAccountId',
    ];

    this.allowedBillKeys = [
      'id',
      'paid',
      'accountId',
      'externalAccountId',
      'billBalance_value',
    ];

    this.state = {
      grid: null,
      billsGrid: null,
      isReady: false,
      billsReady: false,
      selectedAccountRow: null,
      selectedBillRow: null,
      accountRows: [],
      billRows: [],
    };
  }

  STLPROPERTY = 'stl_property';

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccountRow, } = this.state;

    if (selectedAccountRow && selectedAccountRow.id !== selectedRow.id) {
      this.resetBills();
    }

    const account = accountRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedAccountRow: account.raw,
    });
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;
    const selectedBill = billRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedBillRow: selectedBill.raw,
    });
  }

  getAccounts(criteria, onCompletion) {
    this.reset();

    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;
        const headers = this.allowedAccountKeys.map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        const rows = [];

        accounts.forEach((account) => {
          const filtered = _.pick(account, this.allowedAccountKeys);

          rows.push({
            value: Object.values(filtered),
            raw: account,
          });
        });

        this.setState({
          grid: (
            <FieldSet title="Property Tax Accounts">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onAccountRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          ),
          accountRows: rows,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
        this.setState({ isReady: true, });
      });
  }

  getBills(accountId) {
    this.resetBills();

    const criteria = { serviceOfferingId: this.STLPROPERTY, accountId, };

    UtilitiesService.getUtilityBillBySearch(criteria)
      .then((response) => {
        const { bills, } = response.data;

        const headers = this.allowedBillKeys.map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        const rows = [];

        bills.forEach((bill) => {
          const filtered = _.pick(bill, this.allowedBillKeys);

          rows.push({
            value: Object.values(filtered),
            raw: bill,
          });
        });

        this.setState({
          billsGrid: (
            <FieldSet title="Property Tax Bills">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onBillRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          ),
          billRows: rows,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ billsReady: true, });
      });
  }

  formatAccountDetails = (account) => {
    if (!account) {
      return null;
    }

    const { isLoading, selectedAccountRow, } = this.state;

    return (
      <div className="container">
        <hr />
        <div className="row">
          <div className="p-2">
            <STLPropertyDetailedAccountModal account={account} />
          </div>
          <div className="p-2">
            <AsyncActionButton
              onClick={() => {
                this.getBills(account.id);
              }}
              contents="Show Bills"
              isLoading={isLoading}
              variant="success"
              loadingVariant="secondary"
            />
          </div>
          <div className="p-2">
            <AccountLinkForm
              id={selectedAccountRow.id}
              serviceOfferingId={this.STLPROPERTY}
              customerIds={ObjectUtils.formatStringAsJSONArray(selectedAccountRow.customerIds)}
            />
          </div>
        </div>
      </div>
    );
  };

  formatBillDetails = (bill) => {
    if (!bill) {
      return null;
    }

    return (
      <div>
        <hr />
        <div>
          <STLPropertyDetailedBillModal bill={bill} />
        </div>
      </div>
    );
  };

  formatSelectedAccountDisplay(account) {
    if (!account) {
      return null;
    }
    return <p>{`Selected account ID: ${account.id}`}</p>;
  }

  formatSelectedBillDisplay(bill) {
    if (!bill) {
      return null;
    }
    return <p>{`Selected bill ID: ${bill.id}`}</p>;
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.STLPROPERTY;
    this.getAccounts(criteria, event.kill);
  }

  reset() {
    this.setState({
      grid: null,
      billsGrid: null,
      isReady: false,
      billsReady: false,
      selectedAccountRow: null,
      selectedBillRow: null,
      accountRows: [],
      billRows: [],
    });
  }

  resetBills() {
    this.setState({
      billsGrid: null,
      billsReady: false,
      selectedBillRow: null,
      billRows: [],
    });
  }

  showAccounts() {
    const {
      isReady, grid, selectedAccountRow,
    } = this.state;

    if (isReady) {
      return (
        <>
          {grid}
          {this.formatSelectedAccountDisplay(selectedAccountRow)}
          {this.formatAccountDetails(selectedAccountRow)}
        </>
      );
    }

    return null;
  }

  showBills() {
    const {
      billsReady, billsGrid, selectedBillRow,
    } = this.state;

    if (billsReady) {
      return (
        <>
          {billsGrid}
          {this.formatSelectedBillDisplay(selectedBillRow)}
          {this.formatBillDetails(selectedBillRow)}
        </>
      );
    }

    return null;
  }

  showLinkForm() {
    const { linkForm, } = this.state;
    this.setState({ linkForm: !linkForm, });
  }

  render() {
    const { billsReady, } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={event => this.searchOnClick(event)} />
        <div className="row">
          <div className="col-12">
            {this.showAccounts()}
          </div>
          <div className="col-12">
            {billsReady ? this.showBills() : ''}
          </div>
        </div>
      </div>
    );
  }
}

export default STLProperty;
